import { chapters, controls } from "../helpres";

export default {
    mixins: [chapters],
    name: "video-provider-default",
    props: {
        data: {},
    },
    data() {
        return {
            time: "",
            currentItem: null,
            options: {
                debug: false,
                playsinline: true,
                settings: ["quality", "speed"],
            },

            selectedSpeed: 1,
            speedList: [0.5, 0.75, 1, 1.25, 1.5, 1.75, 2],

            activeItem: null,
            isShowChapters: false,
            isShowSettings: false,
        };
    },

    created() {
        this.$bus.$on("enter-chapter", ({ video, chapter }) => {
            this.$bus.$emit("event-select-video", video);
            this.changeChapter(chapter);
        });
    },

    mounted() {
        const player = this.$refs.plyr.player;
        let videoId = this.data.id;

        this.$refs.plyr.player.on("timeupdate", () => {
            let time = player.currentTime;
            localStorage.setItem(`_dmvideo_${videoId}`, time);
        });
    },

    methods: {
        onTouchPause() {
            let elVideo = document.getElementById("video");

            // if (elVideo.classList.contains("has-pause")) {
            //     this.$refs.plyr.player.play();
            // }

            if (elVideo.classList.contains("has-play")) {
                this.$refs.plyr.player.pause();
            }
        },
    },
};
